export default "__VITE_ASSET__DPfjwujx__"